<a [routerLink]="'/'+id" class="px-3 py-2 rounded border text-white text-decoration-none"
    style="background-color:#1F4068;">
    <img src="assets/images/plus.svg" class="me-2 ">Add New
</a>